import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import { MobileTabBar } from './mobile';
import './mobile/mobile.css';
import LoginPage from './pages/LoginPage';
import QueueDashboard from './dispatch/pages/QueueDashboard';
import DispatchHubPage from './dispatch/pages/DispatchHubPage';
import DashboardPage from './dashboard/pages/DashboardPage';
import CallDetailPage from './dispatch/pages/CallDetailPage';
import CallHistoryPage from './dispatch/pages/CallHistoryPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import DriverManagementPage from './pages/admin/DriverManagementPage';
import PropertyManagementPage from './pages/admin/PropertyManagementPage';
import { CallTypesPage, CallReasonsPage, ResolutionReasonsPage, CombinedConfigPage } from './dispatch/admin/ConfigPage';
import VsfManagementPage from './dispatch/admin/VsfManagementPage';
import SettingsPage from './pages/admin/SettingsPage';
import ModuleSetupPage from './pages/admin/ModuleSetupPage';
import MigrationConsolePage from './pages/admin/MigrationConsolePage';
import AccountsListPage from './pages/accounts/AccountsListPage';
import AccountDetailPage from './pages/accounts/AccountDetailPage';
import EmployeeListPage from './admin/pages/EmployeeListPage';
import CompanyProfilePage from './admin/pages/CompanyProfilePage';
import FacilityListPage from './admin/pages/FacilityListPage';
import CompliancePage from './admin/pages/CompliancePage';
import LeaderboardPage from './leaderboard/pages/LeaderboardPage';
import BoardIndexPage from './leaderboard/pages/BoardIndexPage';
import SpotioSetupPage from './leaderboard/pages/SpotioSetupPage';
import GoogleSheetsSetupPage from './leaderboard/pages/GoogleSheetsSetupPage';
import IntegrationsHubPage from './leaderboard/pages/IntegrationsHubPage';
import KpiSetupPage from './leaderboard/pages/KpiSetupPage';
import GroupAssignmentPage from './leaderboard/pages/GroupAssignmentPage';
import DataEntryPage from './leaderboard/pages/DataEntryPage';
import LeaderboardModuleSetupPage from './leaderboard/pages/LeaderboardModuleSetupPage';
import MyWorkDashboard from './workflows/pages/MyWorkDashboard';
import WorkflowItemDetailPage from './workflows/pages/WorkflowItemDetailPage';
import OutsourcedTaskPage from './workflows/pages/OutsourcedTaskPage';
import WorkflowItemListPage from './workflows/pages/WorkflowItemListPage';
import WorkflowSetupPage from './workflows/pages/WorkflowSetupPage';
import WorkflowStageEditor from './workflows/pages/WorkflowStageEditor';
import WorkflowTreePage from './workflows/pages/WorkflowTreePage';
import CreateWorkflowItemPage from './workflows/pages/CreateWorkflowItemPage';
import ExpenseFormPage from './sales/pages/ExpenseFormPage';
import ExpenseHistoryPage from './sales/pages/ExpenseHistoryPage';
import StipendSetupPage from './sales/pages/StipendSetupPage';
import SalesSetupPage from './sales/pages/SalesSetupPage';
import RequestsOverviewPage from './sales/pages/RequestsOverviewPage';
import RequestBucketPage from './sales/pages/RequestBucketPage';
import RequestFormPage from './sales/pages/RequestFormPage';
import SignRequestFormPage from './sales/pages/SignRequestFormPage';
import SignSchedulePage from './sales/pages/SignSchedulePage';
import SignCoveragePage from './sales/pages/SignCoveragePage';
import SignQuickReportPage from './sales/pages/SignQuickReportPage';
import GateAccessReportPage from './sales/pages/GateAccessReportPage';
import SignSetupPage from './sales/pages/SignSetupPage';
import SignRoutePage from './sales/pages/SignRoutePage';
import TaggingRequestFormPage from './sales/pages/TaggingRequestFormPage';
import TaggingSchedulePage from './sales/pages/TaggingSchedulePage';
import TaggingCoveragePage from './sales/pages/TaggingCoveragePage';
import TaggingSetupPage from './sales/pages/TaggingSetupPage';
import TaggingRoutePage from './sales/pages/TaggingRoutePage';
import RequestDetailPage from './sales/pages/RequestDetailPage';
import NewAccountHubPage from './sales/pages/NewAccountHubPage';
import NewAccountFormPage from './sales/pages/NewAccountFormPage';
import NewAccountListPage from './sales/pages/NewAccountListPage';
import NewAccountDetailPage from './sales/pages/NewAccountDetailPage';
import PropertyInfoSheetPage from './sales/pages/PropertyInfoSheetPage';
import ServiceAgreementPage from './sales/pages/ServiceAgreementPage';
import NoticeGeneratorPage from './sales/pages/NoticeGeneratorPage';
import NoticeHistoryPage from './sales/pages/NoticeHistoryPage';
import AuditWizardPage from './sales/pages/AuditWizardPage';
import AuditHistoryPage from './sales/pages/AuditHistoryPage';
import AuditDetailPage from './sales/pages/AuditDetailPage';
import PropertyDetailPage from './sales/pages/PropertyDetailPage';
import DirectorySearchPage from './sales/pages/DirectorySearchPage';
import FwaaOverviewPage from './sales/pages/FwaaOverviewPage';
import FwaaMyAppointmentsPage from './sales/pages/FwaaMyAppointmentsPage';
import FwaaCompanyPage from './sales/pages/FwaaCompanyPage';
import FwaaAttendeePage from './sales/pages/FwaaAttendeePage';
import DirectoryPropertyDetailPage from './sales/pages/DirectoryPropertyDetailPage';
import DirectoryCompaniesPage from './sales/pages/DirectoryCompaniesPage';
import DirectoryCompanyDetailPage from './sales/pages/DirectoryCompanyDetailPage';
import DirectoryOpportunitiesPage from './sales/pages/DirectoryOpportunitiesPage';
import GradingSetupPage from './pages/admin/GradingSetupPage';
import GradingReportPage from './pages/admin/GradingReportPage';
import StoragePage from './pages/admin/StoragePage';
import FormSubmitPage from './components/forms/FormSubmitPage';
import DataPullLogPage from './pages/admin/DataPullLogPage';
import FormsListPage from './components/forms/FormsListPage';
import FormBuilderPage from './components/forms/FormBuilderPage';
import PublicSigningPage from './sales/pages/PublicSigningPage';
import NotificationConfigPage from './admin/pages/NotificationConfigPage';
import TeamsPositionsPage from './admin/pages/TeamsPositionsPage';
import IssueTemplateSetupPage from './admin/pages/IssueTemplateSetupPage';
import ReportIssuePage from './workflows/pages/ReportIssuePage';
import DispatchSetupPage from './dispatch/pages/DispatchSetupPage';
import DamageFundPage from './damagefund/DamageFundPage';
import DamageFundDriverPage from './damagefund/DamageFundDriverPage';
import DamageFundDeductionBatchPage from './damagefund/DamageFundDeductionBatchPage';
import PublicRequestPage from './dispatch/pages/PublicRequestPage';
import ScheduledCallsPage from './dispatch/pages/ScheduledCallsPage';
import WidgetPage from './dispatch/pages/WidgetPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import MaintenanceLandingPage from './maintenance/pages/MaintenanceLandingPage';
import InspectionFormPage from './maintenance/pages/InspectionFormPage';
import InspectionListPage from './maintenance/pages/InspectionListPage';
import InspectionDetailPage from './maintenance/pages/InspectionDetailPage';
import TruckManagementPage from './maintenance/pages/TruckManagementPage';
import ShopManagementPage from './maintenance/pages/ShopManagementPage';
import WorkOrderQueuePage from './maintenance/pages/WorkOrderQueuePage';
import MaintenanceTypesPage from './maintenance/pages/MaintenanceTypesPage';
import TruckMaintenancePage from './maintenance/pages/TruckMaintenancePage';
import MaintenanceSetupPage from './maintenance/pages/MaintenanceSetupPage';
import MaintenanceModuleSetupPage from './maintenance/pages/MaintenanceModuleSetupPage';
import MaintenanceBucketPage from './maintenance/pages/MaintenanceBucketPage';
import { workOrderBucket, incidentBucket, accidentBucket, inspectionBucket, preventiveBucket } from './maintenance/buckets/maintenanceBuckets';
import DriverMaintenanceSubmitPage from './maintenance/pages/DriverMaintenanceSubmitPage';
import ReportIncidentPage from './maintenance/pages/ReportIncidentPage';
import IncidentQueuePage from './maintenance/pages/IncidentQueuePage';
import TruckAvailabilityPage from './maintenance/pages/TruckAvailabilityPage';
import ErrorBoundary from './components/ErrorBoundary';
import InstallPrompt from './components/InstallPrompt';
import NotificationPrompt from './components/NotificationPrompt';
import TimeClockPage from './dispatch/pages/TimeClockPage';
import MyHoursPage from './dispatch/pages/MyHoursPage';
import TimecardReviewPage from './admin/pages/TimecardReviewPage';
import PayrollExportPage from './admin/pages/PayrollExportPage';
import PayrollSettingsPage from './admin/pages/PayrollSettingsPage';
import PinAdminPage from './admin/pages/PinAdminPage';
import ChecklistTemplatesPage from './admin/pages/ChecklistTemplatesPage';
import DriverChatPage from './dispatch/pages/DriverChatPage';
import PtoRequestPage from './dispatch/pages/PtoRequestPage';
import PtoReviewPage from './admin/pages/PtoReviewPage';
import TimeCardsPage from './admin/pages/TimeCardsPage';
import WhosInPage from './admin/pages/WhosInPage';
import PayrollReportPage from './admin/pages/PayrollReportPage';
import TimeClockSetupPage from './admin/pages/TimeClockSetupPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedRoute({ children, permission }) {
  const { user, loading, can } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (permission && !can(permission)) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <div className="loading">Loading...</div>;

  // Standalone pages bypass the app layout entirely
  const isStandalone = window.location.pathname === '/widget';
  const showLayout = user && !isStandalone;

  return (
    <BrowserRouter>
      <ScrollToTop />
      {showLayout && <Sidebar />}
      {showLayout && <MobileTabBar />}
      {showLayout && <InstallPrompt />}
      {showLayout && <NotificationPrompt />}
      <div className={showLayout ? 'app-layout' : ''}>
        <main className={showLayout ? 'main-content' : ''}>
          {showLayout && <div className="watermark" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/logo-icon.png)` }} />}
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />

            {/* Core pages — all authenticated users */}
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/dispatch" element={<ProtectedRoute><DispatchHubPage /></ProtectedRoute>} />
            <Route path="/dispatch" element={<ProtectedRoute><DispatchHubPage /></ProtectedRoute>} />
            <Route path="/queue" element={<ProtectedRoute><QueueDashboard /></ProtectedRoute>} />
            <Route path="/calls/:id" element={<ProtectedRoute><CallDetailPage /></ProtectedRoute>} />
            <Route path="/scheduled" element={<ProtectedRoute><ScheduledCallsPage /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><CallHistoryPage /></ProtectedRoute>} />

            {/* Damage Fund — driver sees own; office/admin see all (scoped server-side) */}
            <Route path="/damage-fund" element={<ProtectedRoute><DamageFundPage /></ProtectedRoute>} />
            <Route path="/damage-fund/driver/:id" element={<ProtectedRoute><DamageFundDriverPage /></ProtectedRoute>} />
            <Route path="/damage-fund/deduction-batch" element={<ProtectedRoute><DamageFundDeductionBatchPage /></ProtectedRoute>} />

            {/* Admin pages — permission-gated */}
            <Route path="/admin/users" element={<ProtectedRoute permission="manage_users"><UserManagementPage /></ProtectedRoute>} />
            <Route path="/admin/drivers" element={<ProtectedRoute permission="manage_drivers"><DriverManagementPage /></ProtectedRoute>} />
            <Route path="/admin/properties" element={<ProtectedRoute permission="manage_properties"><PropertyManagementPage /></ProtectedRoute>} />
            <Route path="/dispatch/setup" element={<ProtectedRoute><DispatchSetupPage /></ProtectedRoute>} />

            {/* Dispatcher PINs + Time Clock + Payroll */}
            <Route path="/timeclock" element={<ProtectedRoute><TimeClockPage /></ProtectedRoute>} />
            <Route path="/my-hours" element={<ProtectedRoute><MyHoursPage /></ProtectedRoute>} />
            <Route path="/admin/timecard-review" element={<ProtectedRoute><TimecardReviewPage /></ProtectedRoute>} />
            <Route path="/admin/payroll" element={<ProtectedRoute><PayrollExportPage /></ProtectedRoute>} />
            <Route path="/admin/payroll-settings" element={<ProtectedRoute permission="system_settings"><PayrollSettingsPage /></ProtectedRoute>} />
            <Route path="/admin/pins" element={<ProtectedRoute><PinAdminPage /></ProtectedRoute>} />
            <Route path="/admin/checklists" element={<ProtectedRoute><ChecklistTemplatesPage /></ProtectedRoute>} />

            {/* Driver Comms + PTO */}
            <Route path="/driver-chat" element={<ProtectedRoute><DriverChatPage /></ProtectedRoute>} />
            <Route path="/pto" element={<ProtectedRoute><PtoRequestPage /></ProtectedRoute>} />
            <Route path="/admin/pto" element={<ProtectedRoute><PtoReviewPage /></ProtectedRoute>} />
            <Route path="/admin/time-cards" element={<ProtectedRoute><TimeCardsPage /></ProtectedRoute>} />
            <Route path="/admin/whos-in" element={<ProtectedRoute><WhosInPage /></ProtectedRoute>} />
            <Route path="/admin/payroll-report" element={<ProtectedRoute><PayrollReportPage /></ProtectedRoute>} />
            <Route path="/admin/timeclock-setup" element={<ProtectedRoute><TimeClockSetupPage /></ProtectedRoute>} />


            <Route path="/admin/config" element={<ProtectedRoute permission="manage_config"><CombinedConfigPage /></ProtectedRoute>} />
            <Route path="/admin/call-types" element={<ProtectedRoute permission="manage_config"><CallTypesPage /></ProtectedRoute>} />
            <Route path="/admin/call-reasons" element={<ProtectedRoute permission="manage_config"><CallReasonsPage /></ProtectedRoute>} />
            <Route path="/admin/resolution-reasons" element={<ProtectedRoute permission="manage_config"><ResolutionReasonsPage /></ProtectedRoute>} />
            <Route path="/admin/vsf-locations" element={<ProtectedRoute permission="manage_config"><VsfManagementPage /></ProtectedRoute>} />
            <Route path="/admin/modules" element={<ProtectedRoute permission="system_settings"><ModuleSetupPage /></ProtectedRoute>} />
            <Route path="/admin/migration" element={<ProtectedRoute permission="system_settings"><MigrationConsolePage /></ProtectedRoute>} />

            {/* Account 360 — unified CRM view. Server enforces the
                accounts_page_enabled flag gate (super_admin always allowed). */}
            <Route path="/accounts" element={<ProtectedRoute><AccountsListPage /></ProtectedRoute>} />
            <Route path="/accounts/:id" element={<ProtectedRoute><AccountDetailPage /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute permission="system_settings"><SettingsPage /></ProtectedRoute>} />

            {/* Admin Module */}
            <Route path="/admin-mod/employees" element={<ProtectedRoute permission="manage_admin"><EmployeeListPage /></ProtectedRoute>} />
            <Route path="/admin-mod/company" element={<ProtectedRoute permission="manage_admin"><CompanyProfilePage /></ProtectedRoute>} />
            <Route path="/admin-mod/facilities" element={<ProtectedRoute permission="manage_admin"><FacilityListPage /></ProtectedRoute>} />
            <Route path="/admin-mod/compliance" element={<ProtectedRoute permission="manage_admin"><CompliancePage /></ProtectedRoute>} />
            <Route path="/admin-mod/notifications" element={<ProtectedRoute permission="manage_admin"><NotificationConfigPage /></ProtectedRoute>} />
            <Route path="/admin/teams-positions" element={<ProtectedRoute permission="manage_admin"><TeamsPositionsPage /></ProtectedRoute>} />
            <Route path="/admin-mod/teams-positions" element={<ProtectedRoute permission="manage_admin"><TeamsPositionsPage /></ProtectedRoute>} />
            <Route path="/admin-mod/issue-templates" element={<ProtectedRoute permission="manage_admin"><IssueTemplateSetupPage /></ProtectedRoute>} />

            {/* Leaderboard — board index + viewing */}
            <Route path="/leaderboard" element={<ProtectedRoute permission="manage_admin"><BoardIndexPage /></ProtectedRoute>} />
            <Route path="/leaderboard/setup" element={<ProtectedRoute><LeaderboardModuleSetupPage /></ProtectedRoute>} />
            <Route path="/leaderboard/:groupName" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />

            {/* Leaderboard — admin setup */}
            <Route path="/admin-mod/leaderboard-kpis" element={<ProtectedRoute permission="manage_admin"><KpiSetupPage /></ProtectedRoute>} />
            <Route path="/admin-mod/leaderboard-groups" element={<ProtectedRoute permission="manage_admin"><GroupAssignmentPage /></ProtectedRoute>} />
            <Route path="/admin-mod/leaderboard-data" element={<ProtectedRoute permission="manage_admin"><DataEntryPage /></ProtectedRoute>} />
            <Route path="/admin-mod/spotio" element={<ProtectedRoute permission="system_settings"><SpotioSetupPage /></ProtectedRoute>} />
            <Route path="/admin-mod/google-sheets" element={<ProtectedRoute permission="system_settings"><GoogleSheetsSetupPage /></ProtectedRoute>} />
            <Route path="/admin-mod/leaderboard-integrations" element={<ProtectedRoute permission="system_settings"><IntegrationsHubPage /></ProtectedRoute>} />

            {/* Workflow Engine */}
            <Route path="/workflow" element={<ProtectedRoute><MyWorkDashboard /></ProtectedRoute>} />
            <Route path="/workflow/my-work" element={<ProtectedRoute><MyWorkDashboard /></ProtectedRoute>} />
            <Route path="/workflow/items" element={<ProtectedRoute><WorkflowItemListPage /></ProtectedRoute>} />
            <Route path="/workflow/items/:id" element={<ProtectedRoute><WorkflowItemDetailPage /></ProtectedRoute>} />
            <Route path="/workflow/tree/:id" element={<ProtectedRoute><WorkflowTreePage /></ProtectedRoute>} />
            <Route path="/workflow/new" element={<ProtectedRoute><CreateWorkflowItemPage /></ProtectedRoute>} />
            <Route path="/workflow/report-issue" element={<ProtectedRoute><ReportIssuePage /></ProtectedRoute>} />
            <Route path="/workflow/setup" element={<ProtectedRoute permission="manage_admin"><WorkflowSetupPage /></ProtectedRoute>} />
            <Route path="/workflow/setup/:id/stages" element={<ProtectedRoute permission="manage_admin"><WorkflowStageEditor /></ProtectedRoute>} />

            {/* Sales module */}
            <Route path="/sales/expenses/new" element={<ProtectedRoute><ExpenseFormPage /></ProtectedRoute>} />
            <Route path="/sales/expenses" element={<ProtectedRoute><ExpenseHistoryPage /></ProtectedRoute>} />
            {/* Requests — unified Refund / No Charge / Take Back system */}
            <Route path="/sales/requests" element={<ProtectedRoute><RequestsOverviewPage /></ProtectedRoute>} />
            {/* Sign Request gets a dedicated 2-step wizard (form + date calendar).
                Static segment outranks the :type dynamic route in RRv6. */}
            <Route path="/sales/requests/sign_request/new" element={<ProtectedRoute><SignRequestFormPage /></ProtectedRoute>} />
            <Route path="/sales/requests/sign_request/schedule" element={<ProtectedRoute><SignSchedulePage /></ProtectedRoute>} />
            <Route path="/sales/sign-setup" element={<ProtectedRoute><SignSetupPage /></ProtectedRoute>} />
            <Route path="/sales/sign-coverage" element={<ProtectedRoute><SignCoveragePage /></ProtectedRoute>} />
            <Route path="/sign-route" element={<ProtectedRoute><SignRoutePage /></ProtectedRoute>} />
            <Route path="/sign-report" element={<ProtectedRoute><SignQuickReportPage /></ProtectedRoute>} />
            <Route path="/gate-report" element={<ProtectedRoute><GateAccessReportPage /></ProtectedRoute>} />
            {/* Tagging Request — carbon copy of the sign routes, one prefix over.
                Same static-before-dynamic rule as sign_request. */}
            <Route path="/sales/requests/tagging_request/new" element={<ProtectedRoute><TaggingRequestFormPage /></ProtectedRoute>} />
            <Route path="/sales/requests/tagging_request/schedule" element={<ProtectedRoute><TaggingSchedulePage /></ProtectedRoute>} />
            <Route path="/sales/tagging-setup" element={<ProtectedRoute><TaggingSetupPage /></ProtectedRoute>} />
            <Route path="/sales/tagging-coverage" element={<ProtectedRoute><TaggingCoveragePage /></ProtectedRoute>} />
            <Route path="/tagging-route" element={<ProtectedRoute><TaggingRoutePage /></ProtectedRoute>} />
            <Route path="/sales/requests/:type/new" element={<ProtectedRoute><RequestFormPage /></ProtectedRoute>} />
            <Route path="/sales/requests/:type/:id" element={<ProtectedRoute><RequestDetailPage /></ProtectedRoute>} />
            <Route path="/sales/requests/:type" element={<ProtectedRoute><RequestBucketPage /></ProtectedRoute>} />
            {/* Legacy /sales/refunds redirects */}
            <Route path="/sales/refunds/new" element={<Navigate to="/sales/requests/refund/new" replace />} />
            <Route path="/sales/refunds/:id" element={<Navigate to="/sales/requests/refund" replace />} />
            <Route path="/sales/refunds" element={<Navigate to="/sales/requests/refund" replace />} />
            <Route path="/sales/setup" element={<ProtectedRoute><SalesSetupPage /></ProtectedRoute>} />
            <Route path="/sales/stipends" element={<ProtectedRoute permission="manage_tasks"><StipendSetupPage /></ProtectedRoute>} />
            <Route path="/sales/accounts" element={<ProtectedRoute><NewAccountHubPage /></ProtectedRoute>} />
            <Route path="/sales/accounts/new" element={<ProtectedRoute><NewAccountFormPage /></ProtectedRoute>} />
            <Route path="/sales/accounts/list" element={<ProtectedRoute><NewAccountListPage /></ProtectedRoute>} />
            <Route path="/sales/accounts/:id" element={<ProtectedRoute><NewAccountDetailPage /></ProtectedRoute>} />
            <Route path="/sales/property-info" element={<ProtectedRoute><PropertyInfoSheetPage /></ProtectedRoute>} />
            <Route path="/sales/service-agreement" element={<ProtectedRoute><ServiceAgreementPage /></ProtectedRoute>} />
            <Route path="/sales/notices" element={<ProtectedRoute><NoticeGeneratorPage /></ProtectedRoute>} />
            <Route path="/sales/notices/history" element={<ProtectedRoute><NoticeHistoryPage /></ProtectedRoute>} />
            <Route path="/sales/audits" element={<ProtectedRoute><AuditHistoryPage /></ProtectedRoute>} />
            <Route path="/sales/audits/new" element={<ProtectedRoute><AuditWizardPage /></ProtectedRoute>} />
            <Route path="/sales/audits/:id" element={<ProtectedRoute><AuditDetailPage /></ProtectedRoute>} />
            <Route path="/sales/properties/:id" element={<ProtectedRoute><PropertyDetailPage /></ProtectedRoute>} />

            {/* Directory — DFW Property Directory (sales tool) */}
            <Route path="/sales/fwaa" element={<ProtectedRoute><FwaaOverviewPage /></ProtectedRoute>} />
            <Route path="/sales/fwaa/my" element={<ProtectedRoute><FwaaMyAppointmentsPage /></ProtectedRoute>} />
            <Route path="/sales/fwaa/companies/:id" element={<ProtectedRoute><FwaaCompanyPage /></ProtectedRoute>} />
            <Route path="/sales/fwaa/attendees/:id" element={<ProtectedRoute><FwaaAttendeePage /></ProtectedRoute>} />
            <Route path="/sales/directory" element={<ProtectedRoute><DirectorySearchPage /></ProtectedRoute>} />
            <Route path="/sales/directory/property/:id" element={<ProtectedRoute><DirectoryPropertyDetailPage /></ProtectedRoute>} />
            <Route path="/sales/directory/companies" element={<ProtectedRoute><DirectoryCompaniesPage /></ProtectedRoute>} />
            <Route path="/sales/directory/companies/:slug" element={<ProtectedRoute><DirectoryCompanyDetailPage /></ProtectedRoute>} />
            <Route path="/sales/directory/opportunities" element={<ProtectedRoute><DirectoryOpportunitiesPage /></ProtectedRoute>} />
            <Route path="/setup/grading" element={<ProtectedRoute permission="manage_admin"><GradingSetupPage /></ProtectedRoute>} />
            <Route path="/admin/grading-report" element={<ProtectedRoute permission="manage_admin"><GradingReportPage /></ProtectedRoute>} />
            <Route path="/admin/storage" element={<ProtectedRoute permission="manage_admin"><StoragePage /></ProtectedRoute>} />

            {/* Workflow Platform — generic form submission (any module) */}
            <Route path="/forms/:formId/submit" element={<ProtectedRoute><FormSubmitPage /></ProtectedRoute>} />
            <Route path="/setup/forms" element={<ProtectedRoute permission="manage_admin"><FormsListPage /></ProtectedRoute>} />
            <Route path="/setup/forms/new" element={<ProtectedRoute permission="manage_admin"><FormBuilderPage /></ProtectedRoute>} />
            <Route path="/admin/data-pulls" element={<ProtectedRoute permission="manage_admin"><DataPullLogPage /></ProtectedRoute>} />
            <Route path="/setup/forms/:id" element={<ProtectedRoute permission="manage_admin"><FormBuilderPage /></ProtectedRoute>} />

            {/* Truck Maintenance module */}
            <Route path="/maintenance" element={<ProtectedRoute><MaintenanceLandingPage /></ProtectedRoute>} />

            {/* Bucket landing pages — Discount-style (KPIs, presets, filters,
                Submit, Export). 5 buckets share MaintenanceBucketPage. */}
            <Route path="/maintenance/work-orders" element={<ProtectedRoute><MaintenanceBucketPage config={workOrderBucket} /></ProtectedRoute>} />
            <Route path="/maintenance/incidents" element={<ProtectedRoute><MaintenanceBucketPage config={incidentBucket} /></ProtectedRoute>} />
            <Route path="/maintenance/accidents" element={<ProtectedRoute><MaintenanceBucketPage config={accidentBucket} /></ProtectedRoute>} />
            <Route path="/maintenance/inspections" element={<ProtectedRoute permission="view_inspections"><MaintenanceBucketPage config={inspectionBucket} /></ProtectedRoute>} />
            <Route path="/maintenance/preventive" element={<ProtectedRoute><MaintenanceBucketPage config={preventiveBucket} /></ProtectedRoute>} />

            {/* Live ops views — sub-routes of each bucket. The original
                kanban / queue / list-with-detail pages live here. Buckets
                still link to them when a user wants the operational view. */}
            <Route path="/maintenance/work-orders/queue" element={<ProtectedRoute><WorkOrderQueuePage /></ProtectedRoute>} />
            <Route path="/maintenance/incidents/queue" element={<ProtectedRoute><IncidentQueuePage /></ProtectedRoute>} />
            <Route path="/maintenance/inspections/list" element={<ProtectedRoute permission="view_inspections"><InspectionListPage /></ProtectedRoute>} />
            <Route path="/maintenance/inspections/:id" element={<ProtectedRoute permission="view_inspections"><InspectionDetailPage /></ProtectedRoute>} />

            {/* Forms / submission paths */}
            <Route path="/maintenance/inspect" element={<ProtectedRoute permission="submit_inspection"><InspectionFormPage /></ProtectedRoute>} />
            <Route path="/maintenance/submit" element={<ProtectedRoute><DriverMaintenanceSubmitPage /></ProtectedRoute>} />
            <Route path="/maintenance/report" element={<ProtectedRoute><ReportIncidentPage /></ProtectedRoute>} />

            {/* Fleet Status — unique, not a bucket. Keeps its own live view. */}
            <Route path="/maintenance/fleet-status" element={<ProtectedRoute><TruckAvailabilityPage /></ProtectedRoute>} />

            {/* PM live status (sub-route of Preventive bucket) */}
            <Route path="/maintenance/status" element={<ProtectedRoute><TruckMaintenancePage /></ProtectedRoute>} />

            {/* Setup / admin pages */}
            <Route path="/maintenance/setup" element={<ProtectedRoute><MaintenanceModuleSetupPage /></ProtectedRoute>} />
            <Route path="/maintenance/trucks" element={<ProtectedRoute permission="manage_trucks"><TruckManagementPage /></ProtectedRoute>} />
            <Route path="/maintenance/types" element={<ProtectedRoute permission="manage_maintenance"><MaintenanceTypesPage /></ProtectedRoute>} />
            <Route path="/maintenance/shops" element={<ProtectedRoute permission="manage_shops"><ShopManagementPage /></ProtectedRoute>} />

            {/* Public pages — no login required */}
            <Route path="/widget" element={<WidgetPage />} />
            <Route path="/request" element={<PublicRequestPage />} />
            <Route path="/sign/:token" element={<PublicSigningPage />} />
            <Route path="/task/:token" element={<OutsourcedTaskPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ErrorBoundary>
  );
}
